import React from "react"

interface NewsItemProps {
  title: string
  image?: any
}
export const NewsItem: React.FC<NewsItemProps> = props => (
  <>
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      <div
        style={{
          textAlign: "left",
          margin: "0.5rem 0.5rem 0.5rem 0",
          flexBasis: "20rem",
          flexGrow: 1,
        }}
      >
        <h4 style={{ margin: "0 0 0.5rem" }}>{props.title}</h4>
        <p>{props.children}</p>
      </div>
      {props.image ? (
        <img
          src={props.image}
          style={{
            flexBasis: "10rem",
            height: "40%",
            width: "40%",
            borderRadius: "0.5rem",
            flexShrink: 0,
            flexGrow: 1,
          }}
          alt={props.title}
        />
      ) : null}
    </div>
    <hr />
  </>
)
